import React from 'react';
import { AnalyticsTrigger, Button, Grid, GridColumn, Icon, Tooltip, TooltipToggle } from 'telia-front-react';
import { CardBottomPrices, TRANSLATIONS_APP_NAME } from '@telia-common-components/shared';
import { formatPrice } from '../../../../util/PriceUtil';
import { normalizeName } from '../../util/TvServicesUtil';
export const mapPackageInclusionsToSections = (inclusions) => {
    const sections = [];
    if (inclusions.tvApps.length) {
        sections.push({
            title: 'tvPackageOfferings.apps',
            items: inclusions.tvApps
        });
    }
    if (inclusions.additionalServices.length) {
        sections.push({
            title: 'tvPackageOfferings.additionalServices',
            items: inclusions.additionalServices
        });
    }
    if (inclusions.themePackages.length) {
        sections.push({
            title: 'tvPackageOfferings.themePackages',
            items: inclusions.themePackages
        });
    }
    return sections;
};
export const renderPacketInfoRow = (icon, rowContent) => {
    return (React.createElement(Grid, { align: ['middle-xs'], gutter: 'xsmall', noWrap: true },
        React.createElement(GridColumn, { align: ['middle-sm'], width: ['min'], noGutter: true },
            React.createElement(Icon, { modifiers: `#${icon}`, size: "sm", align: "none" })),
        React.createElement(GridColumn, { width: ['min'], className: "text-left" }, rowContent)));
};
export const renderViewerSlots = (viewerCount, title, translate, isModal = false) => {
    const viewerSlots = (React.createElement(React.Fragment, null,
        React.createElement("strong", null,
            viewerCount,
            " "),
        translate('tvPackageOfferings.viewerSlots')));
    const tooltipContent = translate('tvPackageOfferings.viewerSlots.tooltipContent');
    if (tooltipContent) {
        const tooltipId = isModal ? `viewers-${title}-modal` : `viewers-${title}`;
        return (React.createElement(React.Fragment, null,
            React.createElement(TooltipToggle, { id: tooltipId }, viewerSlots),
            React.createElement(Tooltip, { referenceElement: `#${tooltipId}` }, tooltipContent)));
    }
    return viewerSlots;
};
export const renderPrices = (prices, translate, translateOrEmpty, showConditionsLink) => {
    var _a;
    const formattedRegularPrice = `${formatPrice(prices.price)} ${translate('tvcomparison.price.permonth')}`;
    if (!!((_a = prices === null || prices === void 0 ? void 0 : prices.discount) === null || _a === void 0 ? void 0 : _a.amount)) {
        const discountPrice = prices.price + prices.discount.amount;
        const discountPriceInfo = prices.discount.info;
        const discountPriceLabel = discountPrice > 0
            ? translate('tvComparison.price', { price: formatPrice(discountPrice) })
            : translate(`tvComparison.offer.name.${discountPriceInfo}`) || translate('tvComparison.tryForFree');
        const campaignUrl = discountPriceInfo && translate(`tvComparison.campaign.${discountPriceInfo}`);
        return (React.createElement(CardBottomPrices, { regularPrice: formattedRegularPrice, discounts: [
                {
                    id: prices.name,
                    price: discountPriceLabel,
                    tooltipText: translateOrEmpty(TRANSLATIONS_APP_NAME, `tvComparison.offer.name.${discountPriceInfo}`),
                    conditionsLink: showConditionsLink && !!campaignUrl ? campaignUrl : undefined
                }
            ] }));
    }
    return React.createElement(CardBottomPrices, { regularPrice: formattedRegularPrice });
};
export const renderOrderServiceCtaButton = (title, serviceOrderUrl, teliaWebSelfServiceUrl, isExistingOffer, translate) => {
    if (isExistingOffer) {
        return (React.createElement(Button, { disabled: true, text: translate('tvPackageOfferings.ordered'), ariaLabel: `${translate('tvPackageOfferings.ordered')} - ${translate(`tvPackageOfferings.packageName.${normalizeName(title)}`)}`, size: 'large', block: true }));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(AnalyticsTrigger, { trigger: {
                id: `CTA - Lähen tellima - ${title}`,
                callback: 'onClick'
            } },
            React.createElement(Button, { url: serviceOrderUrl || `${teliaWebSelfServiceUrl}/teenused/tv/pakett`, text: `${translate('tvPackageOfferings.cta.continue')}`, ariaLabel: `${translate('tvPackageOfferings.cta.continue')} - ${translate(`tvPackageOfferings.packageName.${normalizeName(title)}`)}`, iconRight: "#arrow-right", type: "expressive", size: 'large', block: true }))));
};
